<template>
  <v-layout justify-center row>
  <v-flex xs2>
      <SimpleCard>
        <TaxiChecklistSearchBox
            @search="search"
            @clear="clear"
            :query="query"
        ></TaxiChecklistSearchBox>
      </SimpleCard>
    </v-flex>
    <v-flex xs10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <TaxiChecklistList
              ref="taxiChecklistsList"
              v-if="!loading"
              style="width: 100%"
              @refresh="refresh"
              :pagination="pagination"
              :query="query"
          ></TaxiChecklistList>
        </v-layout>
      </SimpleCard>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import TaxiChecklistList from "@/components/taxi/TaxiChecklistList.vue";
import TaxiChecklistSearchBox from "@/components/taxi/TaxiChecklistSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "drivers",
  components: {
    SimpleCard,
    TaxiChecklistList,
    TaxiChecklistSearchBox,
  },
  data: function () {
    return {
      offset: 0,
      count: 20,
      query: {
        filter: "",
      },
      numPages: 0,
      driverPhotos: [],
      loading: false,
    };
  },
  methods: {
    search: function () {
      console.log("Search");
      this.$refs.taxiChecklistsList.clearAndRefresh();
    },
    refresh: function () {
      this.$refs.taxiChecklistsList.refresh();
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>
